import { render } from "./agreement.vue?vue&type=template&id=ebdb3e3a&scoped=true"
const script = {}

import "./agreement.vue?vue&type=style&index=0&id=ebdb3e3a&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdb3e3a"]])

export default __exports__